import { render, staticRenderFns } from "./TabelaDeContasAReceber.vue?vue&type=template&id=4997ddbd&scoped=true"
import script from "./TabelaDeContasAReceber.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeContasAReceber.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeContasAReceber.vue?vue&type=style&index=0&id=4997ddbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4997ddbd",
  null
  
)

export default component.exports